import { RATING_LEVELS } from "./Constants";

export const calcSectionCRating = (tickRating, submittedCount) => {
    if (!tickRating || submittedCount === 0) return null;

    const levels = RATING_LEVELS.map((level) => ({
        level,
        threshold: tickRating[`rating${level}Tick`],
    }));

    const eligible = levels
        .filter((l) => l.threshold <= submittedCount)
        .sort((a, b) => b.threshold - a.threshold);

    const fallback = levels.reduce((min, cur) => (cur.threshold < min.threshold ? cur : min));

    return (eligible[0] ?? fallback).level;
};